import { FlexRow, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { ChevronUp } from 'baseui/icon';
import { Items, StatefulMenu } from 'baseui/menu';
import { StatefulPopover } from 'baseui/popover';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useAuth } from '../../hooks/useAuth';
import { useStyles } from '../../hooks/useStyles';
import { accountState } from '../../storage/account';
import { selectWorkspaceState, workspaceState } from '../../storage/app';
import { getPageRouteByNavKey } from '../../utils/pages';

type Props = Readonly<{
  isFleet?: boolean;
}>;

export function UserMenu({ isFleet = false }: Props) {
  const { theme, classes } = useStyles();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const setSelectWorkspace = useSetRecoilState(selectWorkspaceState);
  const account = useRecoilValue(accountState);
  const { logout } = useAuth();
  const workspace = useRecoilValue(workspaceState);
  const navigate = useNavigate();

  const onItemSelect = (item: any, close: () => void) => {
    if (item.id === 'workspaces') {
      setSelectWorkspace(true);
    } else if (item.id === 'logout') {
      logout();
    } else if (item.id === 'account') {
      if (!workspace) return;
      const route = getPageRouteByNavKey(workspace._id, item.id);
      if (route) {
        navigate(route.replace(':tab', '0'), { replace: false });
      }
    }
    close();
  };

  const items: Items = useMemo(() => {
    const menuItems: any[] = [
      {
        id: 'workspaces',
        label: (
          <FlexRow
            classNames={classes.centeredStart}
            gap={theme.sizing.scale400}
          >
            <MaterialIcon name="workspaces" />
            Workspaces
          </FlexRow>
        ),
      },
    ];

    if (!isFleet) {
      menuItems.push({
        id: 'account',
        label: (
          <FlexRow
            classNames={classes.centeredStart}
            gap={theme.sizing.scale400}
          >
            <MaterialIcon name="person" />
            Mi cuenta
          </FlexRow>
        ),
      });
    }

    menuItems.push({
      id: 'logout',
      label: (
        <FlexRow
          classNames={classes.centeredStart}
          gap={theme.sizing.scale400}
        >
          <MaterialIcon name="logout" />
          Salir
        </FlexRow>
      ),
    });
    return menuItems;
  }, [isFleet]);

  if (!account) return null;

  return (
    <StatefulPopover
      content={({ close }) => (
        <StatefulMenu
          onItemSelect={({ item }) => onItemSelect(item, close)}
          items={items}
        />
      )}
      placement={'bottomRight'}
      triggerType={'click'}
      onOpen={() => setMenuIsOpen(true)}
      onClose={() => setMenuIsOpen(false)}
    >
      <span>
        <StyledButton
          size="compact"
          kind="tertiary"
          endEnhancer={
            <ChevronUp
              title={''}
              overrides={{
                Svg: {
                  style: {
                    transition: 'transform 0.2s ease-in-out',
                    transform: !menuIsOpen ? 'rotate(180deg)' : undefined,
                  },
                },
              }}
            />
          }
          overrides={{
            BaseButton: {
              style: {
                paddingTop: theme.sizing.scale200,
                paddingBottom: theme.sizing.scale200,
              },
            },
          }}
        >
          <FlexRow
            centered
            gap={theme.sizing.scale300}
          >
            <MaterialIcon name="account_circle" />
            {account.username}
          </FlexRow>
        </StyledButton>
      </span>
    </StatefulPopover>
  );
}
